<template lang="pug">
Container(@loaded="afterload" :itemId="fileId")
    v-chart.chart(:option="option" :autoresize="true" v-for="option, index in Options" :key="index")

    a-input-search(placeholder="input search text" 
        style="width: 200px; margin:10px" 
        v-model="search")

    a-table(:columns="columns" 
        size="small"
        :dataSource="filteredItems" 
        :pagination="{ pageSize: 20, showSizeChanger: true }" 
        :loading="loading")
</template>

<script>
import Container from './Container.vue';
import VChart, {THEME_KEY} from 'vue-echarts';
import _ from 'lodash';
import axios from 'axios';
const host = '/api/fs';

import registerEchartsComponents from './registerEcharts.js';

export default {
    props: ['fileId'],
    data() {
        this.header = {
            headers: {
                'x-jwt': this.$api.jwt,
            }
        };
        
        return {
            items: [],
            datasource: [],
            columns: [],
            search: '',
            loading: false,

            id: '',
            name: '',
            pltOptions: [],
        }
    },
    mounted() {
        registerEchartsComponents();
        // this.load();
    },
    
    methods: {
        afterload(info) {
            this.id = info.id;
            this.name = info.name;
            this.pltOptions = info.pltOptions;

            this.load();
        },
        async load() {
            this.loading = true;
            try {
                let res = await axios.get(`${host}/view/csv/${this.id}`, this.$api.jwtHeader());
                this.items = res.data;
                this.columns = _.keys(res.data[0]).map(key => {
                    return {
                        title: key,
                        dataIndex: key,
                        key: key,
                        sorter: (a, b) => {
                            if (a[key] < b[key]
                                || a[key] == null
                                || b[key] == null
                            ) {
                                return -1;
                            } else if (a[key] > b[key]
                                || a[key] == null
                                || b[key] == null)
                            {
                                return 1;
                            } else
                            {
                                return 0;
                            }
                        }
                    }
                });
                this.loading = false;
            } catch (error) {
                if (error.response && error.response.status == 401){
                    this.$message.error({
                        content: '没有权限',
                        duration: 0,
                    })
                }
                else {
                    this.$message.error('fetch data fail');
                }
                
            }
        }
    },
    computed: {
        filteredItems() {
            return this.items.filter(item => {
                return Object.values(item).some(value => {
                    return String(value).includes(this.search);
                });
            });
        },
        Options() {
            let rlt = this.pltOptions.map((o, i) => {
                let series = o.y.map(j => {
                    return {
                        encode: {
                            x: o.x,
                            y: j,
                        },
                        type: 'line',
                        name: j,
                    };
                });
                return {
                    dataset: {
                        source: this.items,
                    },
                    series,
                    xAxis: {
                        type: 'category',
                    },
                    yAxis: {scale: true},
                    dataZoom: [{
                        type: 'inside',
                        zoomOnMouseWheel: true,
                        moveOnMouseMove: true,
                        moveOnMouseWheel: false,
                    }],
            
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross'
                        }
                    },
                    grid: {
                        left: '3%',
                        right: '4%',
                        bottom: '3%',
                        containLabel: true
                    },
                }
            });

            console.log(rlt);
            return rlt;
            
        }
    },
    components: {
        VChart,
        Container
    }
}
</script>

<style lang="less" scoped>
.chart {
    height: 250px;
    width: 100%;
    // margin: 5px;
}
</style>
